import { Container, FlexGrid, Header, Image, Picture, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { localyticsEvent } from '../../../lib/utils';
import { ANALYTICS_EVENTS, COUNTRY_CODES } from '../../constants';
import GetTheAppButton from '../GetTheAppButton';
import styles from './AppPromo.module.css';

const cx = classnames.bind(styles);

export default function AppPromo({ className, country }) {
  const isUs = country === COUNTRY_CODES.USA;
  const statement = isUs
    ? 'Get our top-rated app to find the best prices quickly while you\'re on the go and to access all GasBack offers.'
    : 'Get our top-rated app to quickly find the best prices and keep track of your vehicle while you\'re on the road.';
  const imageAlt = isUs
    ? 'iPhones with GasBuddy Map and GasBack Deals'
    : 'iPhones with GasBuddy Map and Vehicle Profile';

  function handleLinkClick() {
    localyticsEvent(ANALYTICS_EVENTS.APP_STORE_LINK_CLICK, {
      Store: 'Unknown',
      'Screen Name': 'Home',
      Section: 'AppPromo',
    });
  }

  return (
    <div className={cx('gradient', className)}>
      <Container>
        <FlexGrid>
          <FlexGrid.Column className={cx('statementContainer')} desktop={5}>
            <Image
              lazy
              alt="GasBuddy App"
              className={cx('icon')}
              src="https://static.gasbuddy.com/web/gb-app-2.svg"
            />
            <Header as="h2" className={cx('header')} color="grey">Savings on the go</Header>
            <Text>{statement}</Text>
            <br />
            <br />
            <GetTheAppButton cta={false} onClick={handleLinkClick} />
          </FlexGrid.Column>
          <FlexGrid.Column className={cx('phonesContainer')} desktop={7}>
            <Picture
              lazy
              alt={imageAlt}
              className={cx('phones')}
              src={`https://static.gasbuddy.com/web/consumer/phones/home-phones-${country.toLowerCase()}.png`}
              srcSet={`
                https://static.gasbuddy.com/web/consumer/phones/home-phones-${country.toLowerCase()}@2x.png 2x,
                https://static.gasbuddy.com/web/consumer/phones/home-phones-${country.toLowerCase()}@3x.png 3x
              `}
            >
              <Picture.Source
                srcSet={`
                  https://static.gasbuddy.com/web/consumer/phones/home-phones-${country.toLowerCase()}.webp 1x,
                  https://static.gasbuddy.com/web/consumer/phones/home-phones-${country.toLowerCase()}@2x.webp 2x,
                  https://static.gasbuddy.com/web/consumer/phones/home-phones-${country.toLowerCase()}@3x.webp 3x
                `}
                type="image/webp"
              />
            </Picture>
          </FlexGrid.Column>
        </FlexGrid>
      </Container>
    </div>
  );
}

AppPromo.propTypes = {
  className: PropTypes.string,
  country: PropTypes.oneOf(Object.values(COUNTRY_CODES)),
};

AppPromo.defaultProps = {
  className: undefined,
  country: COUNTRY_CODES.USA,
};
